<template>
  <v-card shaped tile flat>
    <v-card-text class="px-0">
      <v-simple-table dense v-if="current_course">
        <template v-slot:default>
          <thead>
            <tr>
              <th v-for="header in headers" :key="header.id" class="text-left">
                {{ header.text }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td @click="navigateToCourse" style="cursor:pointer">{{ current_course.type_full }}</td>
              <td v-if="!isAdmin">{{ localSc.level || UNDEFINED }}</td>
              <td v-if="isAdmin">
                <v-dialog v-model="studentCourseLevelDialog" width="500">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn plain class="ma-2" v-bind="attrs" v-on="on">
                      {{ localSc.level || UNDEFINED }}
                      <v-icon right dark>mdi-pencil</v-icon>
                    </v-btn>
                  </template>

                  <v-card>
                    <v-card-text>
                      <v-select label="Niveau" :items="current_course.levels" v-model="localSc.level" />

                      <small class="grey--text">* Veuillez sélectionner ou entrer un niveau</small>
                    </v-card-text>

                    <v-card-actions>
                      <v-btn text color="error" @click="cancel()">Annuler</v-btn>

                      <v-btn color="primary" @click="save">Sauvegarder</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </td>
              <td @click="navigateToCourse" style="cursor:pointer">{{ current_course.start | dateToHuman }}</td>
              <td @click="navigateToCourse" style="cursor:pointer">{{ current_course.end | dateToHuman }}</td>
              <td @click="navigateToCourse" style="cursor:pointer">{{ current_course.name }}</td>
              <td>
                <v-btn :href="`/pdf/bilan/${localSc.id}`" text icon color="blue" target="_blank">
                  <v-icon dark>mdi-file-pdf-box</v-icon>
                </v-btn>
                <v-btn class="ml-5" :href="`/pdf/bilan/${localSc.id}?see`" text icon color="blue lighten-2" target="_blank">
                  <v-icon dark>mdi-text-box</v-icon>
                </v-btn>
              </td>
              <td>
                <v-btn :href="`/pdf/presences/${localSc.id}`" text icon color="black" target="_blank">
                  <v-icon dark>mdi-file-pdf-box</v-icon>
                </v-btn>
                <v-btn class="ml-5" :href="`/pdf/presences/${localSc.id}?see`" text icon color="black" target="_blank">
                  <v-icon dark>mdi-text-box</v-icon>
                </v-btn>
              </td>
              <td>
                <v-btn :to="`/courses/${current_course.id}`" text icon color="green">
                  <v-icon>mdi-information-outline</v-icon>
                </v-btn>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card-text>
  </v-card>
</template>

<script>
import StudentCourse from "@/models/StudentCourse"
import Course from "@/models/Course"
import Description from "@/models/Description"
import { cloneDeep } from "lodash"
import { mapGetters } from "vuex"

export default {
  mounted() {
    this.initializeStudentCourse()
  },
  data() {
    return {
      UNDEFINED: Description.UNDEFINED,
      localSc: {
        level: "",
      },
      originalLevel: "",
      studentCourseLevelDialog: false,
      headers: [
        { text: "Type", value: "full_type" },
        { text: "Niveau", value: "level" },
        {
          text: "Début",
          value: "course_start",
          sortable: true,
        },
        { text: "Fin", value: "course_end", sortable: true },
        { text: "Nom du cours", value: "course_name", sortable: true },
        { text: "Bilan", sortable: false },
        { text: "Relevé de fréquentation", sortable: false },
        { text: "Détails", sortable: false },
      ],
    }
  },
  props: {
    student_course_id: {
      required: true,
      type: Number,
    },
  },
  computed: {
    ...mapGetters("Auth", ["isAdmin"]),
    current_course() {
      if (this.localSc && this.localSc.course_id) {
        return Course.find(this.localSc?.course_id)
      }
    },
  },
  watch: {
    student_course_id() {
      this.initializeStudentCourse()
    },
  },
  methods: {
    async initializeStudentCourse() {
      const sc = await StudentCourse.find(this.student_course_id)
      this.localSc = cloneDeep(sc)
      this.originalLevel = this.localSc.level
    },
    async save() {
      this.studentCourseLevelDialog = false
      await StudentCourse.put(this.localSc)
    },
    async cancel() {
      this.studentCourseLevelDialog = false
      this.localSc.level = this.originalLevel
    },
    navigateToCourse() {
      this.$router.push(`/courses/${this.current_course.id}`)
    },
  },
}
</script>
